import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56083232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_video" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_title" }, " 视频资料 ", -1 /* HOISTED */))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "image" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "box_pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_a_tabs, {
          activeKey: $data.tab.active,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (($data.tab.active) = $event)),
          type: "card",
          size: "small",
          tabPosition: _ctx.$Store.Public().isGridMatch('>',_ctx.$Enum.GridEnum.MD)?'left':'top',
          tabBarGutter: 0,
          animated: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tab.data, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: index,
                tab: item.title
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: [20,20] }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$Lodash.slice(item.content,(item.page-1)*$options.getPageSize(),item.page*$options.getPageSize()), (v) => {
                        return (_openBlock(), _createBlock(_component_a_col, {
                          xs: 24,
                          md: 12,
                          lg: 8
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "box_item",
                              onClick: ($event: any) => (_ctx.$Store.Page().openModal('modalVideo',v.video))
                            }, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("i", {
                                  style: _normalizeStyle({background:`url('${v.image}')`})
                                }, null, 4 /* STYLE */)
                              ]),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(v.title), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_5)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */))
                      }), 256 /* UNKEYED_FRAGMENT */)),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_a_pagination, {
                              size: "small",
                              total: item.content.length,
                              pageSize: $options.getPageSize(),
                              "show-total": total=>`共 ${total} 个`,
                              onChange: page=>{item.page=page;}
                            }, null, 8 /* PROPS */, ["total", "pageSize", "show-total", "onChange"])
                          ])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tab"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["activeKey", "tabPosition"])
      ])
    ])
  ]))
}